import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "234",
  "slug": "reading-landscapes-from-space-land-use",
  "title": "Reading Land Use From Above",
  "excerpt": "Visible cover can suggest a use, but it rarely proves ownership, crop type, or activity.",
  "date": "2026-03-15",
  "category": "Geography",
  "image": "https://images.unsplash.com/photo-1503614472-8c93d56e92ce?w=800&q=80",
  "readTime": "2 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Land cover describes what covers the surface: trees, water, bare ground, buildings. Land use describes what people do there. A satellite image can provide evidence for both, but a visible surface does not settle every question about its use."
    },
    {
      "type": "heading",
      "text": "Fields and plantations"
    },
    {
      "type": "paragraph",
      "text": "Straight boundaries, repeated rows, tracks, and irrigation structures can suggest managed land. Look for several features together. A rectangular parcel does not tell you who owns it, and a green field does not identify the crop. Harvest dates and growth stages can change its appearance."
    },
    {
      "type": "heading",
      "text": "Settlement and industry"
    },
    {
      "type": "paragraph",
      "text": "Roofs connected by streets indicate development. Large roofs, yards, sidings, or loading areas may support an industrial interpretation. They do not establish what a business produces or whether a site is operating. Use a land-use map or a named-site reference to check the interpretation."
    },
    {
      "type": "heading",
      "text": "Forest, water, and ambiguous edges"
    },
    {
      "type": "paragraph",
      "text": "Tree cover may be a plantation, regenerating woodland, or another forest type. Water may occupy a natural lake, a reservoir, or a flooded field. Shape and context help you propose an explanation; dates and external records help test it."
    },
    {
      "type": "paragraph",
      "text": "Try marking a small image with three categories: observed cover, likely use, and unresolved areas. Put your confidence beside the interpretation. This produces a more useful reading than assigning a firm label to every pixel."
    }
  ],
  "relatedSlugs": [
    "how-to-read-satellite-image-beginners-guide",
    "how-to-spot-deforestation-from-satellite-imagery"
  ]
};
